import { render } from "./ExcelLogo.vue?vue&type=template&id=6e20af1a"
import script from "./ExcelLogo.vue?vue&type=script&lang=js"
export * from "./ExcelLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__